<template>
  <div class="booking-steps">
    <div class="booking-steps_mobile">
      <div
        class="booking-steps_mobile-indicator"
        :style="`--p:${progressPrcnt};`"
      >
        <div class="booking-steps_mobile-indicator-inner"></div>
        <span class="booking-steps_mobile-indicator-text">{{dispMobileIndicatorText}}</span>
      </div>

      <div class="booking-steps_mobile-body">
        <span class="booking-steps_mobile-current-step">{{dispMobileCurStep}}</span>
        <span class="booking-steps_mobile-next-step">{{dispMobileNextStep}}</span>
      </div>
    </div>

    <ul class="booking-steps_list">
      <li
        class="booking-steps_item"
        v-for="step in steps"
        :key="step.id"
        v-bind:class="{ 'booking-steps_item--active': currentStep >= step.id }"
      >
        <span class="booking-steps_item-num">{{step.id}}</span>
        <span class="booking-steps_item-text">{{step.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'booking-steps',


  data: () => {
    return {

    }
  },

  computed: {
    ...mapState({
      steps: state => state.dictionaries.steps,
      currentStep: state => state.bookingStep,
    }),

    dispMobileIndicatorText() {
      return `${this.currentStep} из ${this.steps.length}`
    },

    progressPrcnt() {
      return +this.currentStep / +this.steps.length * 100
    },

    dispMobileCurStep() {
      return this.steps.find(obj => obj.id === this.currentStep).name
    },

    dispMobileNextStep() {
      return (this.currentStep < this.steps.length) ?
        `Следующий шаг: ${this.steps.find(obj => obj.id === (this.currentStep + 1)).name}`
        : ``
    }
  },
}
</script>

<style lang="sass">
.booking-steps
  width: 100%
  display: flex
  align-items: center
  min-height: px-em(60)
  padding: px-em(10) px-em(33)
  background: #FFFFFF
  box-shadow: 0px 0px px-em(4) rgba(0, 0, 0, 0.25)
  border-radius: px-em(15)
  font-size: 1rem
  position: relative

  &::before
    content: ''
    display: block
    position: absolute
    left: px-em(38)
    right: px-em(38)
    top: 50%
    height: px-em(1)
    background-color: #8A8A8A

  .booking-steps_list
    list-style: none
    padding: 0
    margin: 0
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between

  .booking-steps_item
    margin-bottom: 0

.booking-steps_item
  display: flex
  color: #8A8A8A
  position: relative
  z-index: 1
  background-color: #fff
  padding: 0 px-em(5)

  &--active
    color: #000

    .booking-steps_item-num
      background-color: $prime-color

.booking-steps_item-num
  display: block
  border-radius: 50%
  width: px-em(23)
  height: px-em(23)
  text-align: center
  background-color: #8A8A8A
  color: #fff
  margin-right: px-em(5)

.booking-steps_mobile
  display: none
  align-items: center

.booking-steps_mobile-indicator
  width: px-em(52,12)
  height: px-em(52,12)
  display: flex
  align-items: center
  justify-content: center
  flex-shrink: 0
  // border: 3px solid #E0E0E0
  border-radius: 50%
  position: relative

  &::before
    content: ""
    position: absolute
    border-radius: 50%
    inset: 0
    background: radial-gradient(farthest-side, $prime-color 98%,#0000) top/px-em(4,12) px-em(4,12) no-repeat, conic-gradient($prime-color calc(var(--p)*1%),#0000 0)
    -webkit-mask: radial-gradient(farthest-side, #0000 calc(99% - px-em(4,12)), #000 calc(100% - px-em(4,12)))
    mask: radial-gradient(farthest-side, #0000 calc(99% - px-em(4,12)), #000 calc(100% - px-em(4,12)))
    z-index: 1

  &::after
    content: ""
    position: absolute
    border-radius: 50%
    inset: calc(50% - px-em(4,12) / 2)
    background: $prime-color
    transform: rotate(calc(var(--p) * 3.6deg)) translateY(calc(50% - px-em(52,12) / 2))

.booking-steps_mobile-indicator-inner
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  border: 3px solid #E0E0E0
  border-radius: 50%

.booking-steps_mobile-indicator-text
  color: #696D74
  margin-top: px-em(3,12)

.booking-steps_mobile-body
  min-width: 1px
  flex-grow: 1
  margin-left: px-em(17,12)

.booking-steps_mobile-current-step
  display: block
  font-size: px-em(14,12)
  font-weight: 700
  margin-bottom: 5px

.booking-steps_mobile-next-step
  display: block
  color: #8a8a8a


@media screen and (max-width: $mobile-breakpoint)
  .booking-steps
    padding: px-em(4,12) px-em(12,12)
    // padding-left:
    &::before
      display: none

    .booking-steps_list
      display: none

  .booking-steps_mobile
    display: flex
</style>
